import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { IImportError } from '@/@data'

interface Column {
  id: 'id' | 'row' | 'error'
  label: string
  minWidth?: number
  align?: 'right'
  format?: (value: number) => string
}

const columns: readonly Column[] = [
  { id: 'id', label: '#', minWidth: 50 },
  { id: 'row', label: 'ROW', minWidth: 170 },
  {
    id: 'error',
    label: 'INVALID REASON',
    minWidth: 570
  }
]

export default function InvalidEmployeeTable({ data, ref }: { data: IImportError[]; ref: any }) {
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label='sticky table' ref={ref}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, id) => {
              return (
                <TableRow hover role='checkbox' tabIndex={-1} key={id}>
                  {columns.map(column => {
                    const value = row[column?.id]

                    return (
                      <TableCell key={column.id} align={column.align}>
                        {value ?? id + 1}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
